<template>
  <v-list dense class="grey lighten-4 px-2">
    <v-row dense>
      <v-col cols="12" md="4" class="elevation-2">
        <v-list-item>
          <v-list-item-avatar>
            <v-icon> mdi-school </v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <span class="text-subtitle-1"> SCHOOL</span>
            <v-list-item-title>
              {{ client.currentSchool?.schoolName }}</v-list-item-title
            >
            <v-list-item-subtitle>{{
              client.currentSchool?.streetAddress
            }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-col>
      <v-col cols="12" md="4" class="elevation-2">
        <v-list-item>
          <v-list-item-avatar>
            <v-icon> mdi-account-tie </v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <span class="text-subtitle-1"> TEAM</span>

            <v-list-item-title>{{
              client.currentSchool?.team?.teamName
            }}</v-list-item-title></v-list-item-content
          >
        </v-list-item>
      </v-col>
      <v-col cols="12" md="4" class="elevation-2">
        <v-list-item>
          <v-list-item-avatar>
            <v-icon> mdi-calendar </v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <span class="text-subtitle-1">PLAN</span>
            <div v-for="(plan, index) in currentPlans" :key="index">
              <v-list-item-title
                >{{ plan.planType }} -
                {{ plan.formattedStartDate }}</v-list-item-title
              >
              <v-list-item-subtitle
                v-for="(servicePlan, index) in plan.currentSeitServicePlans"
                :key="index"
                >{{ servicePlan.service }} {{ servicePlan.mandate }}
                <div
                  v-for="(assignment, index) in servicePlan.currentAssignments"
                  :key="index"
                >
                  - {{ assignment.providerName }} ({{ assignment.mandate }})
                </div>
              </v-list-item-subtitle>
            </div>
          </v-list-item-content>
        </v-list-item>
      </v-col>
    </v-row>
  </v-list>
</template>

<script>
export default {
  computed: {
    client() {
      return this.$store.state.clientModule.selectedClient || null;
    },
    currentPlans() {
      return this.$store.state.plansModule.plans.filter((x) => x.isActive);
    },
  },
};
</script>
